import { render, staticRenderFns } from "./ZhuangMenKanban.vue?vue&type=template&id=1df5aea5"
import script from "./ZhuangMenKanban.vue?vue&type=script&lang=js"
export * from "./ZhuangMenKanban.vue?vue&type=script&lang=js"
import style0 from "./ZhuangMenKanban.vue?vue&type=style&index=0&id=1df5aea5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports